<template>
    <v-dialog :value="value" @input="$emit('input', $event)" persistent scrollable max-width="900">
        <v-card :loading="! loaded">
            <v-card-title>
                Edit soal
            </v-card-title>

            <v-card-text>
                <question-form v-if="loaded" ref="form"></question-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-checkbox
                    v-model="verified"
                    label="Terverifikasi"
                    class="mr-2"
                ></v-checkbox>

                <v-btn @click="$emit('input', false)" text>Batal</v-btn>

                <v-btn
                    @click="update" text color="primary"
                    :loading="$store.get('loader/loading', 'updating')"
                    :disabled="! loaded"
                >
                    Simpan
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { sync } from 'vuex-pathify'
import assetUrl from '@/tools/assetUrl'
import QuestionForm from './QuestionForm'

export default {
    props: ['value'],

    components: {
        QuestionForm
    },

    data() {
        return {
            loaded: false,
            old_answers: null,
        }
    },

    computed: {
        ...sync('questionbank/input@*'),
        selectedQuestionId: sync('questionbank/selectedQuestionId')
    },

    methods: {
        update() {
            Promise.all([this.updateAnswers(), this.updateQuestions()])
                .then(() => {
                    this.$refs.form.reset()

                    this.$store.dispatch('questionbank/getQuestions', this.$route.params.questionbank_id)
                    this.$store.dispatch('flash/info', 'Pertanyaan diupdate')
                    this.$emit('input', false)
                })
                .catch(() => {
                    this.$store.dispatch('flash/genericError')
                })
        },

        updateAnswers() {
            return new Promise((resolve, reject) => {
                const answer_ids = []
                const answers = []
                const corrects = []

                this.old_answers.forEach((e, idx) => {
                    if (
                        e.answer != this.answers[idx]
                        || (e.correct && idx != this.correctAnswerIdx)
                        || (! e.correct && idx == this.correctAnswerIdx)
                    ) {
                        answer_ids.push(e.id)
                        answers.push(this.answers[idx])
                        corrects.push(idx == this.correctAnswerIdx)
                    }
                })

                if (answers.length == 0) {
                    return resolve()
                }

                this.$api.patch('questionbank/answer', {answer_ids, answers, corrects}, { loader: 'updating' })
                    .then(response => {
                        if (response.data.updated) {
                            resolve()
                        } else {
                            reject()
                        }
                    })
            })
        },

        updateQuestions() {
            return new Promise((resolve, reject) => {
                const data = this.$store.get('questionbank/inputFormData')
                data.delete('answers[]')
                data.append('_method', 'PUT') // PHP cant read FormData on PUT

                this.$api.post(`questionbank/${this.selectedQuestionId}`, data, { loader: 'updating' })
                    .then(response => {
                        if (response.data.updated) {
                            resolve()
                        } else {
                            reject()
                        }
                    })
            })
        }
    },

    watch: {
        value(to) {
            if (! to) {
                this.selectedQuestionId = null
                this.$refs.form.reset()
                this.$store.commit('questionbank/RESET_INPUT')
            }
        },

        selectedQuestionId(to) {
            if (to) {
                const questionbank_id = this.$route.params.questionbank_id
                const question_id = this.$store.get('questionbank/selectedQuestionId')

                this.$api.get(`questionbank/${questionbank_id}/question/${question_id}`)
                    .then(response => {
                        const data = response.data

                        this.old_answers = data.answers

                        if (data.explanation_video_id) {
                            this.explanationVideoUrl = `https://youtube.com/watch?v=${data.explanation_video_id}`
                        }

                        if (data.image) {
                            this.$api.get(assetUrl(data.image), { responseType: 'blob' })
                                .then(response => {
                                    this.image = response.data
                                })
                        }

                        if (data.explanation_images.length > 0) {
                            const explanationImages = []

                            data.explanation_images.forEach((e) => {
                                explanationImages.push(this.$api.get(assetUrl(e), { responseType: 'blob' }))
                            })

                            Promise.all(explanationImages)
                                .then(responses => {
                                    responses.forEach(e => {
                                        this.explanationImages.push(e.data)
                                    })
                                })
                        }

                        this.label = data.label
                        this.fieldId = data.field_id
                        this.difficultyIndexId = data.difficulty_index_id
                        this.question = data.question
                        this.answers = data.answers.map(e => e.answer)
                        this.answers.push(null)
                        this.correctAnswerIdx = data.answers.findIndex(e => e.correct)
                        this.verified = data.verified == 1

                        this.loaded = true
                    })
            }
        }
    },
}
</script>
